import { L } from '@lib';
import { Tag } from 'antd';
import React from 'react';

interface IProps {
  value: boolean;
}

export const YesNoTag: React.FC<IProps> = ({ value = false }) => {
  return (
    <>{(value && <Tag color="#2db7f5">{L('Yes')}</Tag>) || <Tag color="red">{L('No')}</Tag>}</>
  );
};
